export const Colors = {
  core: {
    white: 'rgba(255, 255, 255, 1.00)',
    black: 'rgba(0, 0, 0, 1.00)',
    neutral: {
      '50': 'rgba(250, 250, 251, 1.00)',
      '100': 'rgba(245, 246, 247, 1.00)',
      '200': 'rgba(235, 237, 239, 1.00)',
      '300': 'rgba(225, 227, 231, 1.00)',
      '400': 'rgba(215, 218, 223, 1.00)',
      '500': 'rgba(195, 200, 207, 1.00)',
      '600': 'rgba(165, 173, 183, 1.00)',
      '700': 'rgba(138, 146, 156, 1.00)',
      '800': 'rgba(113, 119, 128, 1.00)',
      '900': 'rgba(65, 74, 85, 1.00)',
      '1000': 'rgba(47, 49, 63, 1.00)',
    },
    'neutral-transparent': {
      '50': 'rgba(6, 26, 55, 0.02)',
      '100': 'rgba(6, 26, 55, 0.04)',
      '200': 'rgba(6, 26, 55, 0.08)',
      '300': 'rgba(6, 26, 55, 0.12)',
      '400': 'rgba(6, 26, 55, 0.16)',
      '500': 'rgba(6, 26, 55, 0.24)',
      '600': 'rgba(6, 26, 55, 0.36)',
      '700': 'rgba(12, 27, 49, 0.48)',
      '800': 'rgba(18, 29, 43, 0.60)',
      '900': 'rgba(18, 29, 43, 0.80)',
    },
    green: {
      '100': 'rgba(224, 255, 240, 1.00)',
      '150': 'rgba(194, 255, 225, 1.00)',
      '200': 'rgba(161, 247, 205, 1.00)',
      '300': 'rgba(90, 225, 160, 1.00)',
      '475': 'rgba(71, 190, 133, 1.00)',
      '500': 'rgba(50, 187, 120, 1.00)',
      '700': 'rgba(29, 150, 92, 1.00)',
      '900': 'rgba(18, 112, 66, 1.00)',
    },
    'green-transparent': {
      '100': 'rgba(0, 255, 130, 0.12)',
      '150': 'rgba(0, 255, 130, 0.24)',
      '200': 'rgba(2, 232, 120, 0.36)',
      '300': 'rgba(6, 208, 109, 0.64)',
    },
    red: {
      '100': 'rgba(254, 231, 233, 1.00)',
      '200': 'rgba(252, 197, 201, 1.00)',
      '300': 'rgba(249, 134, 143, 1.00)',
      '475': 'rgba(219, 87, 98, 1.00)',
      '500': 'rgba(235, 71, 85, 1.00)',
      '700': 'rgba(201, 29, 43, 1.00)',
      '900': 'rgba(157, 27, 37, 1.00)',
    },
    'red-transparent': {
      '100': 'rgba(247, 59, 74, 0.12)',
      '150': 'rgba(247, 59, 74, 0.24)',
      '200': 'rgba(247, 95, 107, 0.36)',
      '300': 'rgba(245, 66, 81, 0.64)',
    },
    purple: {
      '100': 'rgba(235, 236, 255, 1.00)',
      '200': 'rgba(184, 190, 255, 1.00)',
      '300': 'rgba(132, 143, 255, 1.00)',
      '500': 'rgba(91, 104, 246, 1.00)',
      '700': 'rgba(68, 80, 213, 1.00)',
      '900': 'rgba(49, 56, 135, 1.00)',
    },
    'purple-transparent': {
      '100': 'rgba(91, 104, 246, 0.12)',
      '150': 'rgba(91, 104, 246, 0.24)',
      '200': 'rgba(64, 80, 252, 0.36)',
      '300': 'rgba(64, 80, 252, 0.64)',
    },
    yellow: {
      '100': 'rgba(255, 245, 204, 1.00)',
      '200': 'rgba(253, 232, 163, 1.00)',
      '300': 'rgba(255, 215, 89, 1.00)',
      '400': 'rgba(255, 197, 41, 1.00)',
      '500': 'rgba(255, 178, 0, 1.00)',
      '700': 'rgba(245, 131, 0, 1.00)',
      '900': 'rgba(233, 101, 7, 1.00)',
      '1000': 'rgba(204, 91, 0, 1.00)',
    },
    'yellow-transparent': {
      '50': 'rgba(255, 204, 0, 0.12)',
      '100': 'rgba(255, 204, 0, 0.20)',
      '200': 'rgba(250, 192, 0, 0.36)',
      '300': 'rgba(255, 191, 0, 0.64)',
    },
    shark: {
      '800': 'rgba(63, 63, 70, 1.00)',
      '850': 'rgba(53, 54, 61, 1.00)',
      '900': 'rgba(44, 45, 53, 1.00)',
      '950': 'rgba(35, 36, 44, 1.00)',
      '1000': 'rgba(26, 27, 35, 1.00)',
    },
    'white-transparent': {
      '50': 'rgba(255, 255, 255, 0.02)',
      '100': 'rgba(255, 255, 255, 0.04)',
      '200': 'rgba(255, 255, 255, 0.08)',
      '300': 'rgba(255, 255, 255, 0.12)',
      '400': 'rgba(255, 255, 255, 0.16)',
      '500': 'rgba(255, 255, 255, 0.24)',
      '600': 'rgba(255, 255, 255, 0.36)',
      '700': 'rgba(255, 255, 255, 0.48)',
      '800': 'rgba(255, 255, 255, 0.64)',
      '900': 'rgba(255, 255, 255, 0.80)',
    },
    'black-transparent': {
      '50': 'rgba(0, 0, 0, 0.02)',
      '100': 'rgba(0, 0, 0, 0.04)',
      '200': 'rgba(0, 0, 0, 0.08)',
      '300': 'rgba(0, 0, 0, 0.12)',
      '400': 'rgba(0, 0, 0, 0.16)',
      '500': 'rgba(0, 0, 0, 0.24)',
      '600': 'rgba(0, 0, 0, 0.36)',
      '700': 'rgba(0, 0, 0, 0.48)',
      '800': 'rgba(0, 0, 0, 0.64)',
      '900': 'rgba(0, 0, 0, 0.80)',
    },
    'bolt-plus': {
      '1': 'rgba(37, 59, 255, 1.00)',
      '2': 'rgba(0, 133, 255, 1.00)',
    },
    'brand-green': 'rgba(42, 156, 100, 1.00)',
    'brand-green-dark': 'rgba(12, 44, 28, 1.00)',
  },
  'core-accessible': {
    white: 'rgba(255, 255, 255, 1.00)',
    'brand-green': 'rgba(42, 156, 100, 1.00)',
    green: {
      'on-light': {
        '1': 'rgba(251, 254, 252, 1.00)',
        '2': 'rgba(241, 248, 244, 1.00)',
        '3': 'rgba(231, 246, 237, 1.00)',
        '4': 'rgba(217, 239, 225, 1.00)',
        '5': 'rgba(200, 231, 212, 1.00)',
        '6': 'rgba(180, 219, 195, 1.00)',
        '7': 'rgba(152, 203, 172, 1.00)',
        '8': 'rgba(111, 181, 141, 1.00)',
        '9': 'rgba(43, 134, 89, 1.00)',
        '10': 'rgba(24, 120, 76, 1.00)',
        '11': 'rgba(20, 123, 81, 1.00)',
        '12': 'rgba(8, 31, 20, 1.00)',
        '950': 'rgba(8, 31, 20, 1.00)',
      },
      'on-dark': {
        '1': 'rgba(4, 14, 9, 1.00)',
        '2': 'rgba(6, 22, 14, 1.00)',
        '3': 'rgba(12, 44, 28, 1.00)',
        '4': 'rgba(11, 60, 37, 1.00)',
        '5': 'rgba(15, 74, 46, 1.00)',
        '6': 'rgba(23, 89, 57, 1.00)',
        '7': 'rgba(29, 106, 69, 1.00)',
        '8': 'rgba(32, 126, 82, 1.00)',
        '9': 'rgba(43, 134, 89, 1.00)',
        '10': 'rgba(24, 120, 76, 1.00)',
        '11': 'rgba(116, 239, 170, 1.00)',
        '12': 'rgba(221, 255, 233, 1.00)',
        '500': 'rgba(43, 134, 89, 1.00)',
      },
    },
    'green-transparent': {
      'on-light': {
        '100': 'rgba(0, 160, 64, 0.09)',
        '800': 'rgba(0, 112, 66, 0.92)',
      },
    },
    red: {
      'on-light': {
        '1': 'rgba(255, 252, 252, 1.00)',
        '2': 'rgba(255, 247, 247, 1.00)',
        '3': 'rgba(255, 234, 234, 1.00)',
        '4': 'rgba(255, 219, 219, 1.00)',
        '5': 'rgba(255, 205, 205, 1.00)',
        '6': 'rgba(255, 189, 190, 1.00)',
        '7': 'rgba(246, 169, 171, 1.00)',
        '8': 'rgba(238, 142, 146, 1.00)',
        '9': 'rgba(222, 25, 41, 1.00)',
        '10': 'rgba(206, 0, 25, 1.00)',
        '11': 'rgba(178, 15, 28, 1.00)',
        '12': 'rgba(54, 0, 3, 1.00)',
        '950': 'rgba(54, 0, 3, 1.00)',
      },
      'on-dark': {
        '1': 'rgba(17, 2, 3, 1.00)',
        '2': 'rgba(26, 3, 5, 1.00)',
        '3': 'rgba(62, 15, 14, 1.00)',
        '4': 'rgba(85, 6, 10, 1.00)',
        '5': 'rgba(102, 13, 17, 1.00)',
        '6': 'rgba(120, 28, 28, 1.00)',
        '7': 'rgba(147, 44, 43, 1.00)',
        '8': 'rgba(189, 59, 57, 1.00)',
        '9': 'rgba(222, 25, 41, 1.00)',
        '10': 'rgba(206, 0, 25, 1.00)',
        '11': 'rgba(255, 159, 148, 1.00)',
        '12': 'rgba(255, 228, 224, 1.00)',
        '500': 'rgba(222, 25, 41, 1.00)',
      },
    },
    'red-transparent': {
      'on-light': {
        '100': 'rgba(255, 0, 0, 0.08)',
        '800': 'rgba(173, 0, 14, 0.94)',
      },
    },
    yellow: {
      'on-light': {
        '1': 'rgba(254, 253, 251, 1.00)',
        '2': 'rgba(255, 249, 233, 1.00)',
        '3': 'rgba(255, 240, 197, 1.00)',
        '4': 'rgba(255, 231, 173, 1.00)',
        '5': 'rgba(255, 219, 144, 1.00)',
        '6': 'rgba(255, 205, 115, 1.00)',
        '7': 'rgba(243, 188, 99, 1.00)',
        '8': 'rgba(226, 163, 50, 1.00)',
        '9': 'rgba(255, 178, 0, 1.00)',
        '10': 'rgba(255, 161, 0, 1.00)',
        '11': 'rgba(158, 91, 0, 1.00)',
        '12': 'rgba(63, 45, 15, 1.00)',
        '950': 'rgba(63, 45, 15, 1.00)',
      },
      'on-dark': {
        '1': 'rgba(20, 14, 0, 1.00)',
        '2': 'rgba(30, 21, 0, 1.00)',
        '3': 'rgba(47, 32, 8, 1.00)',
        '4': 'rgba(64, 39, 0, 1.00)',
        '5': 'rgba(77, 48, 0, 1.00)',
        '6': 'rgba(91, 62, 5, 1.00)',
        '7': 'rgba(111, 80, 24, 1.00)',
        '8': 'rgba(141, 102, 33, 1.00)',
        '9': 'rgba(255, 178, 0, 1.00)',
        '10': 'rgba(255, 161, 0, 1.00)',
        '11': 'rgba(255, 191, 53, 1.00)',
        '12': 'rgba(255, 233, 194, 1.00)',
        '500': 'rgba(255, 178, 0, 1.00)',
      },
    },
    'yellow-transparent': {
      'on-light': {
        '100': 'rgba(255, 190, 0, 0.23)',
        '800': 'rgba(158, 91, 0, 1.00)',
      },
    },
    purple: {
      'on-light': {
        '1': 'rgba(253, 253, 255, 1.00)',
        '2': 'rgba(247, 249, 255, 1.00)',
        '3': 'rgba(238, 242, 255, 1.00)',
        '4': 'rgba(225, 232, 255, 1.00)',
        '5': 'rgba(211, 221, 255, 1.00)',
        '6': 'rgba(194, 207, 255, 1.00)',
        '7': 'rgba(172, 188, 255, 1.00)',
        '8': 'rgba(143, 161, 247, 1.00)',
        '9': 'rgba(89, 102, 243, 1.00)',
        '10': 'rgba(79, 91, 218, 1.00)',
        '11': 'rgba(68, 19, 217, 1.00)',
        '12': 'rgba(15, 23, 85, 1.00)',
        '950': 'rgba(15, 23, 85, 1.00)',
      },
      'on-dark': {
        '1': 'rgba(7, 8, 19, 1.00)',
        '2': 'rgba(11, 12, 29, 1.00)',
        '3': 'rgba(27, 33, 78, 1.00)',
        '4': 'rgba(35, 41, 107, 1.00)',
        '5': 'rgba(43, 51, 126, 1.00)',
        '6': 'rgba(52, 62, 142, 1.00)',
        '7': 'rgba(63, 74, 163, 1.00)',
        '8': 'rgba(74, 86, 192, 1.00)',
        '9': 'rgba(89, 102, 243, 1.00)',
        '10': 'rgba(79, 91, 218, 1.00)',
        '11': 'rgba(175, 180, 250, 1.00)',
        '12': 'rgba(224, 235, 255, 1.00)',
        '500': 'rgba(89, 102, 243, 1.00)',
      },
    },
    'purple-transparent': {
      'on-light': {
        '100': 'rgba(0, 60, 255, 0.07)',
        '800': 'rgba(56, 4, 215, 0.94)',
      },
    },
    sage: {
      'on-light': {
        '1': 'rgba(251, 253, 252, 1.00)',
        '2': 'rgba(247, 249, 248, 1.00)',
        '3': 'rgba(238, 241, 240, 1.00)',
        '4': 'rgba(230, 233, 232, 1.00)',
        '5': 'rgba(222, 226, 225, 1.00)',
        '6': 'rgba(215, 218, 217, 1.00)',
        '7': 'rgba(203, 207, 206, 1.00)',
        '8': 'rgba(184, 188, 187, 1.00)',
        '9': 'rgba(134, 142, 139, 1.00)',
        '10': 'rgba(124, 132, 129, 1.00)',
        '11': 'rgba(95, 101, 99, 1.00)',
        '12': 'rgba(25, 31, 28, 1.00)',
        '950': 'rgba(25, 31, 28, 1.00)',
      },
      'on-dark': {
        '1': 'rgba(14, 16, 16, 1.00)',
        '2': 'rgba(22, 26, 24, 1.00)',
        '3': 'rgba(32, 34, 33, 1.00)',
        '4': 'rgba(39, 42, 41, 1.00)',
        '5': 'rgba(46, 49, 48, 1.00)',
        '6': 'rgba(55, 59, 57, 1.00)',
        '7': 'rgba(67, 73, 71, 1.00)',
        '8': 'rgba(91, 98, 95, 1.00)',
        '9': 'rgba(99, 112, 107, 1.00)',
        '10': 'rgba(113, 125, 121, 1.00)',
        '11': 'rgba(173, 181, 178, 1.00)',
        '12': 'rgba(236, 238, 237, 1.00)',
        '500': 'rgba(99, 112, 107, 1.00)',
      },
    },
    'sage-transparent': {
      'on-light': {
        '100': 'rgba(0, 45, 30, 0.07)',
        '150': 'rgba(0, 31, 21, 0.10)',
        '800': 'rgba(0, 10, 7, 0.63)',
      },
    },
    black: 'rgba(0, 0, 0, 1.00)',
    'brand-green-dark': 'rgba(12, 44, 28, 1.00)',
    'green-alpha': {
      'on-light': {
        '1': 'rgba(0, 192, 64, 0.02)',
        '2': 'rgba(0, 122, 41, 0.05)',
        '3': 'rgba(0, 160, 64, 0.09)',
        '4': 'rgba(0, 148, 54, 0.15)',
        '5': 'rgba(0, 144, 56, 0.22)',
        '6': 'rgba(1, 133, 52, 0.29)',
        '7': 'rgba(0, 127, 50, 0.40)',
        '8': 'rgba(0, 124, 54, 0.56)',
        '9': 'rgba(0, 110, 55, 0.83)',
        '10': 'rgba(0, 106, 57, 0.91)',
        '11': 'rgba(0, 112, 66, 0.92)',
        '12': 'rgba(8, 31, 20, 1.00)',
      },
      'on-dark': {
        '1': 'rgba(0, 186, 0, 0.01)',
        '2': 'rgba(78, 250, 123, 0.05)',
        '3': 'rgba(0, 255, 110, 0.12)',
        '4': 'rgba(0, 255, 130, 0.18)',
        '5': 'rgba(18, 255, 140, 0.24)',
        '6': 'rgba(44, 255, 151, 0.31)',
        '7': 'rgba(53, 253, 156, 0.38)',
        '8': 'rgba(52, 253, 158, 0.46)',
        '9': 'rgba(73, 255, 164, 0.49)',
        '10': 'rgba(37, 255, 154, 0.44)',
        '11': 'rgba(119, 248, 176, 0.96)',
        '12': 'rgba(221, 255, 233, 1.00)',
      },
    },
    'red-alpha': {
      'on-light': {
        '1': 'rgba(255, 0, 0, 0.01)',
        '2': 'rgba(255, 0, 0, 0.03)',
        '3': 'rgba(255, 0, 0, 0.08)',
        '4': 'rgba(255, 0, 0, 0.14)',
        '5': 'rgba(255, 0, 0, 0.20)',
        '6': 'rgba(255, 0, 4, 0.26)',
        '7': 'rgba(229, 0, 6, 0.34)',
        '8': 'rgba(217, 0, 10, 0.44)',
        '9': 'rgba(218, 0, 18, 0.90)',
        '10': 'rgba(206, 0, 25, 1.00)',
        '11': 'rgba(173, 0, 14, 0.94)',
        '12': 'rgba(51, 0, 3, 0.96)',
      },
      'on-dark': {
        '1': 'rgba(240, 0, 0, 0.04)',
        '2': 'rgba(245, 41, 29, 0.08)',
        '3': 'rgba(254, 11, 6, 0.20)',
        '4': 'rgba(253, 0, 0, 0.30)',
        '5': 'rgba(253, 8, 19, 0.37)',
        '6': 'rgba(253, 44, 44, 0.44)',
        '7': 'rgba(255, 67, 65, 0.55)',
        '8': 'rgba(254, 75, 73, 0.73)',
        '9': 'rgba(254, 27, 45, 0.87)',
        '10': 'rgba(206, 0, 25, 1.00)',
        '11': 'rgba(255, 159, 148, 1.00)',
        '12': 'rgba(255, 228, 224, 1.00)',
      },
    },
    'yellow-alpha': {
      'on-light': {
        '1': 'rgba(192, 128, 0, 0.02)',
        '2': 'rgba(255, 186, 0, 0.09)',
        '3': 'rgba(255, 190, 0, 0.23)',
        '4': 'rgba(255, 181, 0, 0.32)',
        '5': 'rgba(255, 173, 0, 0.44)',
        '6': 'rgba(255, 164, 0, 0.55)',
        '7': 'rgba(236, 146, 0, 0.61)',
        '8': 'rgba(219, 141, 0, 0.80)',
        '9': 'rgba(255, 178, 0, 1.00)',
        '10': 'rgba(255, 161, 0, 1.00)',
        '11': 'rgba(158, 91, 0, 1.00)',
        '12': 'rgba(51, 32, 0, 0.94)',
      },
      'on-dark': {
        '1': 'rgba(227, 0, 0, 0.02)',
        '2': 'rgba(254, 128, 1, 0.06)',
        '3': 'rgba(255, 133, 0, 0.14)',
        '4': 'rgba(255, 127, 0, 0.21)',
        '5': 'rgba(254, 138, 0, 0.26)',
        '6': 'rgba(254, 160, 0, 0.32)',
        '7': 'rgba(255, 174, 35, 0.40)',
        '8': 'rgba(254, 178, 48, 0.53)',
        '9': 'rgba(255, 178, 0, 1.00)',
        '10': 'rgba(255, 161, 0, 1.00)',
        '11': 'rgba(255, 191, 53, 1.00)',
        '12': 'rgba(255, 233, 194, 1.00)',
      },
    },
    'purple-alpha': {
      'on-light': {
        '1': 'rgba(0, 0, 255, 0.01)',
        '2': 'rgba(0, 64, 255, 0.03)',
        '3': 'rgba(0, 60, 255, 0.07)',
        '4': 'rgba(0, 60, 255, 0.12)',
        '5': 'rgba(0, 58, 255, 0.17)',
        '6': 'rgba(0, 55, 255, 0.24)',
        '7': 'rgba(0, 50, 255, 0.33)',
        '8': 'rgba(0, 41, 237, 0.44)',
        '9': 'rgba(0, 20, 237, 0.65)',
        '10': 'rgba(0, 18, 202, 0.69)',
        '11': 'rgba(56, 4, 215, 0.94)',
        '12': 'rgba(0, 8, 74, 0.94)',
      },
      'on-dark': {
        '1': 'rgba(0, 0, 252, 0.05)',
        '2': 'rgba(53, 75, 252, 0.10)',
        '3': 'rgba(64, 81, 252, 0.26)',
        '4': 'rgba(68, 81, 253, 0.38)',
        '5': 'rgba(76, 91, 253, 0.46)',
        '6': 'rgba(85, 102, 254, 0.53)',
        '7': 'rgba(94, 111, 255, 0.62)',
        '8': 'rgba(95, 111, 255, 0.74)',
        '9': 'rgba(92, 106, 254, 0.95)',
        '10': 'rgba(92, 105, 255, 0.81)',
        '11': 'rgba(178, 183, 255, 0.98)',
        '12': 'rgba(224, 235, 255, 1.00)',
      },
    },
    'sage-alpha': {
      'on-light': {
        '1': 'rgba(0, 128, 64, 0.02)',
        '2': 'rgba(0, 64, 32, 0.03)',
        '3': 'rgba(0, 45, 30, 0.07)',
        '4': 'rgba(0, 31, 21, 0.10)',
        '5': 'rgba(0, 31, 24, 0.13)',
        '6': 'rgba(0, 20, 13, 0.16)',
        '7': 'rgba(0, 20, 15, 0.20)',
        '8': 'rgba(0, 15, 11, 0.28)',
        '9': 'rgba(0, 17, 11, 0.47)',
        '10': 'rgba(0, 16, 10, 0.51)',
        '11': 'rgba(0, 10, 7, 0.63)',
        '12': 'rgba(0, 8, 5, 0.90)',
      },
      'on-dark': {
        '1': 'rgba(15, 16, 1, 0.06)',
        '2': 'rgba(185, 227, 181, 0.05)',
        '3': 'rgba(244, 246, 233, 0.08)',
        '4': 'rgba(242, 253, 244, 0.11)',
        '5': 'rgba(241, 250, 243, 0.14)',
        '6': 'rgba(242, 255, 244, 0.18)',
        '7': 'rgba(236, 255, 246, 0.24)',
        '8': 'rgba(238, 254, 245, 0.35)',
        '9': 'rgba(225, 253, 241, 0.40)',
        '10': 'rgba(229, 253, 245, 0.46)',
        '11': 'rgba(244, 254, 249, 0.69)',
        '12': 'rgba(253, 255, 254, 0.93)',
      },
    },
    'black-alpha': {
      '1': 'rgba(0, 0, 0, 0.01)',
      '2': 'rgba(0, 0, 0, 0.02)',
      '3': 'rgba(0, 0, 0, 0.06)',
      '4': 'rgba(0, 0, 0, 0.09)',
      '5': 'rgba(0, 0, 0, 0.12)',
      '6': 'rgba(0, 0, 0, 0.15)',
      '7': 'rgba(0, 0, 0, 0.19)',
      '8': 'rgba(0, 0, 0, 0.27)',
      '9': 'rgba(0, 0, 0, 0.45)',
      '10': 'rgba(0, 0, 0, 0.49)',
      '11': 'rgba(0, 0, 0, 0.61)',
      '12': 'rgba(0, 0, 0, 0.88)',
    },
  },
  Colors: {
    'Sea Driver': {
      '1': 'rgba(254, 254, 255, 1.00)',
      '2': 'rgba(249, 249, 255, 1.00)',
      '3': 'rgba(243, 245, 255, 1.00)',
      '4': 'rgba(241, 241, 254, 1.00)',
      '5': 'rgba(209, 218, 255, 1.00)',
      '6': 'rgba(176, 191, 255, 1.00)',
      '7': 'rgba(146, 164, 255, 1.00)',
      '8': 'rgba(116, 134, 255, 1.00)',
      '10': 'rgba(71, 72, 233, 1.00)',
      '11': 'rgba(57, 10, 199, 1.00)',
      '12': 'rgba(14, 0, 83, 1.00)',
    },
  },
  layer: {
    'floor-0-grouped': 'rgba(238, 241, 240, 1.00)',
    'floor-1': 'rgba(255, 255, 255, 1.00)',
    'floor-2': 'rgba(255, 255, 255, 1.00)',
    'floor-3': 'rgba(255, 255, 255, 1.00)',
  },
  content: {
    primary: 'rgba(25, 31, 28, 1.00)',
    secondary: 'rgba(0, 10, 7, 0.63)',
    tertiary: 'rgba(0, 17, 11, 0.47)',
    'action-primary': 'rgba(0, 112, 66, 0.92)',
    'action-secondary': 'rgba(0, 110, 55, 0.83)',
    'danger-primary': 'rgba(173, 0, 14, 0.94)',
    'danger-secondary': 'rgba(218, 0, 18, 0.90)',
    'warning-primary': 'rgba(158, 91, 0, 1.00)',
    'positive-primary': 'rgba(0, 112, 66, 0.92)',
    'positive-secondary': 'rgba(0, 110, 55, 0.83)',
    'promo-primary': 'rgba(56, 4, 215, 0.94)',
    'promo-secondary': 'rgba(0, 20, 237, 0.65)',
    'link-primary': 'rgba(0, 112, 66, 0.92)',
    'link-secondary': 'rgba(0, 110, 55, 0.83)',
    'primary-inverted': 'rgba(253, 255, 254, 0.93)',
    'secondary-inverted': 'rgba(244, 254, 249, 0.69)',
    'action-primary-inverted': 'rgba(116, 239, 170, 1.00)',
  },
  'content-active': {
    'link-primary': 'rgba(8, 31, 20, 1.00)',
    'action-primary-inverted': 'rgba(221, 255, 233, 1.00)',
  },
  bg: {
    'neutral-primary': 'rgba(14, 16, 16, 1.00)',
    'neutral-secondary': 'rgba(0, 45, 30, 0.07)',
    'neutral-secondary-hard': 'rgba(0, 20, 13, 0.16)',
    'action-primary': 'rgba(43, 134, 89, 1.00)',
    'action-secondary': 'rgba(0, 160, 64, 0.09)',
    'danger-primary': 'rgba(222, 25, 41, 1.00)',
    'danger-secondary': 'rgba(255, 0, 0, 0.08)',
    'warning-primary': 'rgba(255, 178, 0, 1.00)',
    'warning-secondary': 'rgba(255, 190, 0, 0.23)',
    'warning-secondary-hard': 'rgba(255, 181, 0, 0.32)',
    'positive-primary': 'rgba(43, 134, 89, 1.00)',
    'positive-secondary': 'rgba(0, 160, 64, 0.09)',
    'promo-primary': 'rgba(89, 102, 243, 1.00)',
    'promo-secondary': 'rgba(0, 60, 255, 0.07)',
  },
  'bg-active': {
    'neutral-primary': 'rgba(22, 26, 24, 1.00)',
    'neutral-secondary': 'rgba(0, 31, 24, 0.13)',
    'neutral-secondary-hard': 'rgba(0, 15, 11, 0.28)',
    'action-primary': 'rgba(24, 120, 76, 1.00)',
    'action-secondary': 'rgba(0, 144, 56, 0.22)',
    'danger-primary': 'rgba(206, 0, 25, 1.00)',
    'danger-secondary': 'rgba(255, 0, 0, 0.20)',
    'warning-primary': 'rgba(255, 161, 0, 1.00)',
    'warning-secondary': 'rgba(255, 173, 0, 0.44)',
    'warning-secondary-hard': 'rgba(255, 173, 0, 0.44)',
    'positive-primary': 'rgba(24, 120, 76, 1.00)',
    'positive-secondary': 'rgba(0, 144, 56, 0.22)',
    'promo-primary': 'rgba(79, 91, 218, 1.00)',
    'promo-secondary': 'rgba(0, 58, 255, 0.17)',
  },
  special: {
    bg: {
      disabled: 'rgba(0, 45, 30, 0.07)',
      zebra: 'rgba(0, 64, 32, 0.03)',
    },
    nulled: 'rgba(0, 0, 0, 0.00)',
    scrim: 'rgba(0, 0, 0, 0.28)',
    brand: 'rgba(42, 156, 100, 1.00)',
    'brand-alt': 'rgba(12, 44, 28, 1.00)',
  },
  border: {
    'neutral-primary': 'rgba(0, 17, 11, 0.47)',
    'neutral-secondary': 'rgba(0, 20, 13, 0.16)',
    separator: 'rgba(0, 45, 30, 0.07)',
    'action-primary': 'rgba(43, 134, 89, 1.00)',
    'action-secondary': 'rgba(1, 133, 52, 0.29)',
    'danger-primary': 'rgba(222, 25, 41, 1.00)',
    'danger-secondary': 'rgba(255, 0, 4, 0.26)',
    'warning-primary': 'rgba(255, 178, 0, 1.00)',
    'warning-secondary': 'rgba(255, 164, 0, 0.55)',
    'positive-primary': 'rgba(43, 134, 89, 1.00)',
    'positive-secondary': 'rgba(1, 133, 52, 0.29)',
    'promo-primary': 'rgba(89, 102, 243, 1.00)',
    'promo-secondary': 'rgba(0, 55, 255, 0.24)',
  },
  'border-active': {
    'neutral-secondary': 'rgba(0, 15, 11, 0.28)',
    'action-primary': 'rgba(24, 120, 76, 1.00)',
    'danger-primary': 'rgba(206, 0, 25, 1.00)',
    'neutral-primary': 'rgba(0, 16, 10, 0.51)',
  },
  static: {
    bg: {
      'key-light': 'rgba(255, 255, 255, 1.00)',
      'key-dark': 'rgba(0, 0, 0, 1.00)',
      'neutral-secondary-light': 'rgba(244, 246, 233, 0.08)',
      'key-secondary-dark': 'rgba(0, 45, 30, 0.07)',
      'neutral-primary-dark': 'rgba(32, 34, 33, 1.00)',
    },
    content: {
      'key-light': 'rgba(255, 255, 255, 1.00)',
      'primary-light': 'rgba(236, 238, 237, 1.00)',
      'key-dark': 'rgba(0, 0, 0, 1.00)',
      'primary-dark': 'rgba(25, 31, 28, 1.00)',
      'secondary-dark': 'rgba(0, 10, 7, 0.63)',
      'tertiary-dark': 'rgba(0, 17, 11, 0.47)',
      'tertiary-light': 'rgba(225, 253, 241, 0.40)',
      'secondary-light': 'rgba(244, 254, 249, 0.69)',
    },
    'bg-active': {
      'key-light': 'rgba(247, 249, 248, 1.00)',
    },
  },
};
